var map = {
	"./about-us.svg": 766,
	"./betting-icon.svg": 767,
	"./bonus.svg": 768,
	"./coin.png": 769,
	"./contact-us.svg": 770,
	"./download-app.svg": 771,
	"./edit-btn.svg": 772,
	"./feedback.svg": 773,
	"./global.svg": 774,
	"./info-centre.svg": 775,
	"./instant-rebate.svg": 776,
	"./mall-icon.svg": 777,
	"./message.svg": 778,
	"./redemption-icon.svg": 779,
	"./referral.svg": 780,
	"./resp-gaming.svg": 781,
	"./security.svg": 782,
	"./transaction-icon.svg": 783,
	"./vip-icon.svg": 784,
	"./wallet-icon.svg": 785
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 174;